module.exports = __webpack_public_path__ + "static/media/1562622695573_1681412820869.7a772fd8.jpeg";